module.exports = __webpack_public_path__ + "static/media/arunkumar.e7415c51.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/arunkumar.webp
// module id = 712
// module chunks = 0